import { css } from "@emotion/react"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"
import { container } from "@mkt/cp/src/styles/Functions"
import { above } from "@mkt/cp/src/styles/Breakpoints"

export const faq = css`
  padding-top: 32px;
  padding-bottom: 8px;

  ${above["m"]} {
    padding-top: 72px;
    padding-bottom: 48px;
  }

  .iq-accordion {
    &__head-content {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      padding-right: 20px;

      ${above["m"]} {
        font-size: 20px;
        line-height: 28px;
      }
    }

    &__item--open .iq-accordion__item-body {
      padding: 0 0 16px;

      ${above["m"]} {
        padding: 0 0 24px;
      }
    }

    &__item-body {
      .iq-text {
        color: ${colorsCP["gray-50"]};

        p {
          margin-bottom: 10px;
        }

        ul {
          padding-left: 24px;
          margin-block: 20px;

          > li {
            list-style: disc;

            &::marker {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
`
export const faqContainer = css`
  ${container};

  ${above["m"]} {
    width: 664px;
  }
`
export const faqTitle = css`
  font-weight: 300;
  margin-bottom: 32px;

  ${above["m"]} {
    text-align: center;
    margin-bottom: 36px;
  }
`
